import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWarnerbrosDotComponent } from './simple-icons-warnerbros-dot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWarnerbrosDotComponent ],
    exports:      [ SimpleIconsWarnerbrosDotComponent ],
    bootstrap:    []
})
export class SimpleIconsWarnerbrosDotModule {}
